import { render, staticRenderFns } from "./InputProduct.vue?vue&type=template&id=1f1039c5&scoped=true&"
import script from "./InputProduct.vue?vue&type=script&lang=js&"
export * from "./InputProduct.vue?vue&type=script&lang=js&"
import style0 from "./InputProduct.vue?vue&type=style&index=0&id=1f1039c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1039c5",
  null
  
)

export default component.exports